import { render, staticRenderFns } from "./chartCallcenter.vue?vue&type=template&id=e4840b3a&"
import script from "./chartCallcenter.vue?vue&type=script&lang=js&"
export * from "./chartCallcenter.vue?vue&type=script&lang=js&"
import style0 from "./chartCallcenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports